import validator from "validator";

// Password regex
// const passwordRegex = new RegExp(
//   "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
// );

export const loginValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.email.trim()))
    errors.email = "Please enter email address";

  if (data?.email && !validator.isEmail(data.email))
    errors.email = "Email address must be valid";

  if (validator.isEmpty(data?.password.trim()))
    errors.password = "Please enter password";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const forgotPasswordValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.email.trim()))
    errors.email = "Please enter email address";

  if (data?.email && !validator.isEmail(data.email.trim()))
    errors.email = "Email address must be valid";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const resetPasswordValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.newPassword?.trim()))
    errors.newPassword = "Please enter new password";

    if (!validator.isEmpty(data?.newPassword?.trim()) && data?.newPassword?.length < 6)
    errors.newPassword = "Password must be at least 6 characters";

  if (validator.isEmpty(data?.confirmPassword?.trim()))
    errors.confirmPassword = "Please enter confirm password";

 

  if (
    !validator.isEmpty(data?.confirmPassword) &&
    data.newPassword !== data.confirmPassword
  )
    errors.confirmPassword = "New & Confirm password does not match";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};
